import styled from "styled-components";
import COLORS from "components/atoms/colors";
import logo from "assets/images/common/logo-white.svg";
import logoGray from "assets/images/common/logo-light-gray.svg";

// 이용 제한 페이지
const Guide = () => {
  return (
    <>
      <Header>
      <h1
              onClick={() => window.open("https://macodi.co.kr", "_blank")}
              className="cursor-pointer"
            >
              <img
                src={logo}
                alt="macodi"
              />
            </h1>
      </Header>
      <Container>
        <img src={logoGray} alt="" className="w-[220px]" />
        <Text>
          이 사이트는 현재 PC에서만 접속 가능합니다.
          <br />
          추후 업데이트를 통해 태블릿 / 모바일에서도 이용가능하도록
          지원하겠습니다.
        </Text>
      </Container>
    </>
  );
};

const Header = styled.header`
  display: flex;
  align-items: center;
  background-color: ${COLORS.primary.active};
  padding: 0px 20px;
  height: 60px;
`;

const Container = styled.main`
  height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
`;

const Text = styled.p`
  margin-top: 20px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: -0.6px;
  word-break: keep-all;
`;

export default Guide;
